import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

// core components

import { Link } from "gatsby";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import blogStyle from "assets/jss/material-kit-react/views/landingPageSections/blogStyle.jsx";

import about from "data/about-hero.json";

class AboutUsSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgFluid
    );

    return (
      <div id="team" className={classes.section}>
        <GridContainer justify="flex-start">
          <GridItem xs={11}>
          <h2 className={classes.title}>
          About Us
          <br/>
          <small className={classes.smallTitle}>We the Shareholders Public Benefit Corporation (PBC)</small>
          </h2>
          <Link to="/about">
            <h3>Find out more.</h3>
          </Link>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(blogStyle)(AboutUsSection);